import React from 'react'
import CompanyRequestRow from './CompanyRequestRow'

export default function CompanyRequestTable({ requests }) {
  return (
    <div className='company-request-table-wrapper'>
      <table className="dome-table dome-table-striped" style={{ width: '100%' }}>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Alias</th>
            <th>Logo</th>
            <th>Type</th>
            <th>Approval status</th>
            <th>Source Request</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{requests && requests.map((request, key) => <CompanyRequestRow key={key} request={request} />)}</tbody>
      </table>
    </div>
  )
}
